import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { global } from "@shared/libs/Global";
import SnLabel from "@shared/components/SnLabel";
import SnComboBox from "@shared/components/SnComboBox";
import SnRadioBox from "@shared/components/SnRadioBox";
import SnPeriodBox from "@shared/components/SnPeriodBox";
import SnNumberBox from "@shared/components/SnNumberBox";
import { StyleSettings } from "src/styles/StyleSettings";
import SnDateMonthBox from "@shared/components/SnDateMonthBox";
interface popupProps {
  selectedData?: any;
  Menuprops?: any;
}
const SN_SAL_BAS_REG_001_POP_01_bak = forwardRef(
  ({ selectedData, Menuprops }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const today1 = new Date();
    const todayform = `${today1.getFullYear()}${(today1.getMonth() + 1)
      .toString()
      .padStart(2, "0")}${today1.getDate().toString().padStart(2, "0")}`;

    const frameFont = StyleSettings.font;

    //#region datFormats
    const popDate = new Date();
    popDate.setDate(1);
    const firstDayOfMonth = `${popDate.getFullYear()}${(popDate.getMonth() + 1)
      .toString()
      .padStart(2, "0")}${popDate.getDate().toString().padStart(2, "0")}`;

    popDate.setMonth(popDate.getMonth() + 1);
    const nextMonth = `${popDate.getFullYear()}${(popDate.getMonth() + 1)
      .toString()
      .padStart(2, "0")}${popDate.getDate().toString().padStart(2, "0")}`;
    const today = new Date();

    // First day of next month
    const nextMonthFirst = new Date(
      today.getFullYear(),
      today.getMonth() + 1,
      1
    );
    const nextMonthFirstDay = `${nextMonthFirst.getFullYear()}${(
      nextMonthFirst.getMonth() + 1
    )
      .toString()
      .padStart(
        2,
        "0"
      )}${nextMonthFirst.getDate().toString().padStart(2, "0")}`;

    // Last day of next month
    const nextMonthLast = new Date(
      today.getFullYear(),
      today.getMonth() + 2,
      0
    );
    const nextMonthLastDay = `${nextMonthLast.getFullYear()}${(
      nextMonthLast.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}${nextMonthLast.getDate().toString().padStart(2, "0")}`;
    //Last day of current month
    const currentMonthLast = new Date(
      today.getFullYear(),
      today.getMonth() + 1,
      0
    );
    const currentMonthLastDay = `${currentMonthLast.getFullYear()}${(
      currentMonthLast.getMonth() + 1
    )
      .toString()
      .padStart(
        2,
        "0"
      )}${currentMonthLast.getDate().toString().padStart(2, "0")}`;

    const [virtualTable, setVirtualTable] = useState<any[]>([]);
    const [radioMonth, setRadioMonth] = useState<any>("1");
    const [radioDay, setRadioDay] = useState<any>("-1");
    const [radioFixamt, setRadioFixamt] = useState<any>("1");
    const [radioRate, setRadioRate] = useState<any>("-1");
    const [radioSale1, setRadioSale1] = useState<any>("0");
    const [radioSale2, setRadioSale2] = useState<any>("-1");
    const [combo1, setCombo1] = useState<any>();
    const [combo2, setCombo2] = useState<any>("");
    const [combo3, setCombo3] = useState<any>("");
    const [dt1, setDt1] = useState<any>(todayform.toString().substring(0, 6));
    const [dt2, setDt2] = useState<any>(
      nextMonthFirstDay.toString().substring(0, 6)
    );
    const [pd1start, setpd1start] = useState<any>(firstDayOfMonth);
    const [pd1end, setpd1end] = useState<any>(currentMonthLastDay);
    const [pd2start, setpd2start] = useState<any>(nextMonthFirstDay);
    const [pd2end, setpd2end] = useState<any>(nextMonthLastDay);
    const [noBox1, setNoBox1] = useState<number>(0);
    const [noBox2, setNoBox2] = useState<number>(0);

    const [editSale2, seteditSale2] = useState<boolean>(true);
    const [editSale1, seteditSale1] = useState<boolean>(false);
    const [editNoBox1, seteditNoBox1] = useState<boolean>(false);
    const [editNoBox2, seteditNoBox2] = useState<boolean>(false);
    //#endregion
    useImperativeHandle(ref, () => ({
      getSelectedRow: () => [...virtualTable],
    }));
    useEffect(() => {
      const fetchform = async () => {
        try {
          setCombo1("000");
          setCombo2("001");
          setCombo3("001");
        } catch (error) {}
      };
      fetchform();
    }, []);
    useEffect(() => {
      const updateForm = async () => {
        try {
          await addDt();
        } catch (error) {}
      };
      updateForm();
    }, [
      combo1,
      combo2,
      combo3,
      dt1,
      dt2,
      pd1start,
      pd1end,
      pd2start,
      pd2end,
      radioDay,
      radioMonth,
      radioFixamt,
      radioRate,
      radioSale1,
      radioSale2,
      noBox1,
      noBox2,
    ]);

    //#region valueChanged
    //to get the controls' current value
    const vcCombo1 = async (id: string) => {
      setCombo1(id);
    };
    const vcCombo2 = async (id: string) => {
      setCombo2(id);
    };
    const vcCombo3 = async (id: string) => {
      setCombo3(id);
    };
    const vcDt1 = async (id: string) => {
      setDt1(id);
    };
    const vcDt2 = async (id: string) => {
      setDt2(id);
    };
    const vcRadioM = async (id: string) => {
      if (id === "1") {
        setRadioDay("-1");
        setRadioMonth(id);
      }
    };
    const vcRadioD = async (id: string) => {
      if (id === "1") {
        setRadioDay(id);
        setRadioMonth("-1");
      }
    };
    const vcRadioa = async (id: string) => {
      if (id === "1") {
        setRadioFixamt(id);
        setRadioRate("-1");
        setRadioSale2("-1");
        setRadioSale1("0");
        seteditSale2(true);
        seteditSale1(false);
        //setNoBox2(0);
        seteditNoBox1(false);
        seteditNoBox2(true);
      }
    };
    const vcRadioR = async (id: string) => {
      if (id === "1") {
        setRadioFixamt("-1");
        setRadioRate(id);
        setRadioSale2("0");
        setRadioSale1("-1");
        seteditSale2(false);
        seteditSale1(true);
        //setNoBox1(0);
        seteditNoBox1(true);
        seteditNoBox2(false);
      }
    };
    const vcRadioN1 = async (id: number) => {
      setNoBox1(id);
      //  await addDt();
    };
    const vcRadioN2 = async (id: number) => {
      setNoBox2(id);
    };
    const vcRadioS1 = async (id: string) => {
      setRadioSale1(id);
    };
    const vcRadioS2 = async (id: string) => {
      setRadioSale2(id);
    };
    const periodBox1Changed = async (start: string, end: string) => {
      setpd1start(start);
      setpd1end(end);
    };
    const periodBox2Changed = async (start: string, end: string) => {
      setpd2start(start);
      setpd2end(end);
    };
    //#region addDt
    //getting return data
    const addDt = async () => {
      const newRow = {
        cd_exch: combo1,
        tp_um1: combo2,
        tp_um2: combo3,
        dt_from: "",
        dt_to: "",
        dtDayStartCrt: "",
        dtDayEndCrt: "",
        sepreator1: 0,
        sepreator2: 0,
        am: 0,
      };
      if (radioMonth === "1") {
        newRow.dt_from = dt1.substring(0, 6);
        newRow.dt_to = dt2.substring(0, 6);
        newRow.dtDayStartCrt = dt1.substring(0, 6);
        newRow.dtDayEndCrt = dt2.substring(0, 6);
      }
      if (radioDay === "1") {
        newRow.dt_from = pd2start;
        newRow.dt_to = pd2end;
        newRow.dtDayStartCrt = pd1start;
        newRow.dtDayEndCrt = pd1end;
      }
      if (radioFixamt === "1") {
        newRow.sepreator1 = 0;
        newRow.sepreator2 = Number(radioSale1);
        newRow.am = noBox1;
      }
      if (radioRate === "1") {
        newRow.sepreator1 = 1;
        newRow.sepreator2 = Number(radioSale2);
        newRow.am = noBox2;
      }
      setVirtualTable([newRow]);
    };

    //#region UI
    return (
      <div className="h-[40vh] mt-5px flex flex-col space-y-4 p-2 ">
        <div className="w-full flex flex space-x-3">
          <SnLabel text="환종" type="label" />
          {/*cd_exch*/}
          <div style={{ width: 150 }}>
            <SnComboBox
              code="MAS051"
              defaultValue={"000"}
              onValueChanged={vcCombo1}
              isRequired={true}
            />
          </div>
          <SnLabel text="기준단가유형" type="label" />
          {/*tp_um1*/}
          <div style={{ width: 150 }}>
            <SnComboBox
              code="SAL001"
              defaultValue={"001"}
              onValueChanged={vcCombo2}
              isRequired={true}
            />
          </div>
          <SnLabel text="적용단가유형" type="label" />
          {/*tp_um2*/}
          <div style={{ width: 150 }}>
            <SnComboBox
              code="SAL001"
              defaultValue={"001"}
              onValueChanged={vcCombo3}
              isRequired={true}
            />
          </div>
        </div>

        <div className="w-full flex flex ">
          <SnLabel text="적용기간 설정" type="label" />
          <div
            className=" border-t flex-1 mt-2"
            style={{ borderColor: "rgb(11,12,105)" }}
            tabIndex={-1}
          ></div>
        </div>

        <div className="w-full flex flex">
          <SnRadioBox
            defaultValue={radioMonth}
            sql={"select '1' as code, '월 기준' as name"}
            onValueChanged={vcRadioM}
          />
          <div style={{ width: 360 }} />
          <SnRadioBox
            defaultValue={radioDay}
            sql={"select '1' as code, '일 기준' as name"}
            onValueChanged={vcRadioD}
          />
        </div>

        <div className="w-full flex flex ">
          <SnLabel text="조회월" type="label" />
          <div style={{ width: 150 }}>
            <SnDateMonthBox defaultValue={dt1} onValueChanged={vcDt1} />
          </div>
          <div style={{ width: 180 }} />
          <SnLabel text="조회일" type="label" />
          <div style={{ width: 250 }}>
            <SnPeriodBox
              defaultValue={`${pd1start},${pd1end}`}
              onValueChanged={periodBox1Changed}
            />
          </div>
        </div>

        <div className="w-full flex flex ">
          <SnLabel text="생성월" type="label" />
          <div style={{ width: 150 }}>
            <SnDateMonthBox defaultValue={dt2} onValueChanged={vcDt2} />
          </div>
          <div style={{ width: 180 }} />
          <SnLabel text="생성일" type="label" />
          <div style={{ width: 250 }}>
            <SnPeriodBox
              defaultValue={`${pd2start},${pd2end}`}
              onValueChanged={periodBox2Changed}
            />
          </div>
        </div>
        <div className="w-full flex flex ">
          <SnLabel text="할인할증 방안 설정" type="label" />
          <div
            className=" border-t flex-1 mt-2"
            style={{ borderColor: "rgb(11,12,105)" }}
            tabIndex={-1}
          ></div>
        </div>

        <div className="w-full flex flex ">
          <SnRadioBox
            defaultValue={radioFixamt}
            sql={"select '1' as code, '정액' as name"}
            onValueChanged={vcRadioa}
          />
          <div style={{ width: 378 }} />
          <SnRadioBox
            defaultValue={radioRate}
            sql={"select '1' as code, '정률' as name"}
            onValueChanged={vcRadioR}
          />
        </div>

        <div className="w-full flex flex ">
          <SnRadioBox
            defaultValue={radioSale1}
            sql={
              "select '0' as code, '할인' as name union all select '1' as code, '할증' as name"
            }
            onValueChanged={vcRadioS1}
            isReadOnly={editSale1}
          />

          <div style={{ width: 150 }}>
            <SnNumberBox
              defaultValue={noBox1}
              onValueChanged={vcRadioN1}
              isReadOnly={editNoBox1}
            />
          </div>
          <div className="ml-2 mt-1" style={{ fontSize: frameFont }}>
            원
          </div>

          <div style={{ width: 150 }} />
          <SnRadioBox
            defaultValue={radioSale2}
            sql={
              "select '0' as code, '할인' as name union all select '1' as code, '할증' as name"
            }
            onValueChanged={vcRadioS2}
            isReadOnly={editSale2}
          />

          <div style={{ width: 150 }}>
            <SnNumberBox
              defaultValue={noBox2}
              onValueChanged={vcRadioN2}
              isReadOnly={editNoBox2}
            />
          </div>
          <div className="ml-2 mt-1">%</div>
        </div>
      </div>
    );
  }
);

export default SN_SAL_BAS_REG_001_POP_01_bak;
